import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-vodafone',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Vodafone icon</title><path d="M12 0A12 12 0 0 0 0 12A12 12 0 0 0 12 24A12 12 0 0 0 24 12A12 12 0 0 0 12 0M16.25 1.12C16.57 1.12 16.9 1.15 17.11 1.22C14.94 1.67 13.21 3.69 13.22 6C13.22 6.05 13.22 6.11 13.23 6.17C16.87 7.06 18.5 9.25 18.5 12.28C18.54 15.31 16.14 18.64 12.09 18.65C8.82 18.66 5.41 15.86 5.39 11.37C5.38 8.4 7 5.54 9.04 3.85C11.04 2.19 13.77 1.13 16.25 1.12Z"/></svg>`,
    styles: []
})
export class SimpleIconsVodafoneComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#E60000';
    @Input() className: string = 'simple-icons-vodafone'
    constructor() {}
    ngOnInit(): void {}
}
